<template>
  <!-- 编辑步骤 -->
  <div class="step-list">
    <div class="step-list-item">
      <div class="step-list-item-left">
        <div class="step-list-item-left-index">
          <span>1</span>
        </div>
        <div class="step-list-item-left-info">
          <div class="step-list-item-left-info__title">
            <span>选择标签</span>
          </div>
          <div class="step-list-item-left-info__tip">
            <span>所有标签可通过重复点击多次添加</span>
          </div>
        </div>
      </div>
      <div class="step-list-item-right">
        <div class="tags-wrap">
          <div class="tag">标签类别</div>
          <div class="tag-list">
            <div class="tag-list-arrow"></div>
            <div class="tag-list-item1">标签1</div>
            <div class="tag-list-item2">标签2</div>
          </div>
        </div>
      </div>
    </div>
    <div class="step-list-item">
      <div class="step-list-item-left">
        <div class="step-list-item-left-index">
          <span>2</span>
        </div>
        <div class="step-list-item-left-info">
          <div class="step-list-item-left-info__title">
            <span>编辑标签</span>
          </div>
          <div class="step-list-item-left-info__tip">
            <span
              >选择的多个标签，均显示在“标签规则”中，可直接编辑对应标签条件</span
            >
          </div>
        </div>
      </div>
      <div class="step-list-item-right">
        <div class="form-wrap">
          <el-select
            v-model="selectValue"
            placeholder="选择内容"
            style="width: 100px"
          >
            <el-option label="选择内容" value="选择内容"></el-option>
          </el-select>
          <div class="input-wrap">
            <el-input class="input-w40 active" v-model="value"></el-input>
            <div class="margin-10"><span>-</span></div>
            <el-input class="input-w40" v-model="value1"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="step-list-item">
      <div class="step-list-item-left">
        <div class="step-list-item-left-index">
          <span>3</span>
        </div>
        <div class="step-list-item-left-info">
          <div class="step-list-item-left-info__title">
            <span>确认组内标签关系</span>
          </div>
          <div class="step-list-item-left-info__tip">
            <span>组内标签之间可以实现交集或并集关系</span>
          </div>
        </div>
      </div>
      <div class="step-list-item-right">
        <div class="type-wrap">
          <el-radio-group v-model="radio">
            <el-radio label="1">交</el-radio>
            <el-radio label="2">并</el-radio>
          </el-radio-group>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <div class="step-list-item">
      <div class="step-list-item-left">
        <div class="step-list-item-left-index">
          <span>4</span>
        </div>
        <div class="step-list-item-left-info">
          <div class="step-list-item-left-info__title">
            <span>确认大分组之间关系</span>
          </div>
          <div class="step-list-item-left-info__tip">
            <span
              >最多可添加3个大分组，大分组之间可以实现交集、并集或差集关系</span
            >
          </div>
        </div>
      </div>
      <div class="step-list-item-right">
        <div class="type-wrap margin-r10">
          <div>
            <img :src="`${globalCdn}/customer/j.png`" alt="" />
          </div>
        </div>
        <div class="type-wrap margin-r10">
          <div>
            <img :src="`${globalCdn}/customer/b.png`" alt="" />
          </div>
        </div>
        <div class="type-wrap">
          <div>
            <img :src="`${globalCdn}/customer/c.png`" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const globalCdn = "https://cdn-image.yucrm.cn/images/yuqiyunzhou";
export default {
  data() {
    return {
      globalCdn,
      value: 8,
      value1: 0,
      selectValue: "选择内容",
      radio: "1",
    };
  },
};
</script>

<style lang="scss" scoped>
.step-list {
  margin-top: 30px;
  &-item {
    position: relative;
    background-color: #f8f8f8;
    padding: 20px 25px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    width: 723px;
    margin: 0 auto;
    margin-bottom: 16px;
    height: 70px;
    &-left {
      display: flex;
      &-index {
        width: 16px;
        height: 16px;
        min-width: 16px;
        border-radius: 50%;
        text-align: center;
        line-height: 16px;
        color: var(--themeColor);
        border: 1px solid var(--themeColor);
        font-size: 16px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-info {
        &__title {
          margin-bottom: 10px;
          color: #333;
          font-size: 14px;
          font-weight: 500;
        }
        &__tip {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}
.tags-wrap {
  display: flex;
  align-items: center;
  .tag {
    background-color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    color: #666;
    border: 1px solid #d9d9d9;
  }
  .tag-list {
    position: relative;
    margin-left: 10px;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    &-item1 {
      padding: 6px 8px 6px 4px;
      border-radius: 4px;
      min-width: 55px;
      text-align: center;
      color: var(--themeColor);
    }
    &-item2 {
      padding: 6px 8px 6px 4px;
      border-radius: 4px;
      color: #666;
      min-width: 55px;
      text-align: center;
    }
    &-arrow {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      border-width: 6px;
      filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
      margin-right: 3px;
      border-top-width: 0px;
      border-bottom-color: #d9d9d9;
      left: -9px;
      transform: rotate(-90deg);
      top: 50%;
      &::after {
        content: " ";
        border-width: 6px;
        top: 1px;
        margin-left: -6px;
        border-top-width: 0px;
        border-bottom-color: #fff;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        border-bottom-color: #fff;
        left: 0px;
      }
    }
  }
}
.form-wrap {
  display: flex;
  align-items: center;
  pointer-events: none;
  .input-wrap {
    display: flex;
    align-items: center;
    margin-left: 10px;
    :deep(.input-w40) {
      width: 40px;
    }
    :deep(.active) {
      border-color: var(--themeColor);
      color: var(--themeColor);
    }
    .margin-10 {
      margin: 0px 5px;
    }
  }
}
.step-list-item-right {
  display: flex;
  align-items: center;
}
.type-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.type-item {
  margin-top: 5px;
}
.margin-r40 {
  margin-right: 40px;
}
.margin-r10 {
  margin-right: 10px;
}
</style>
